export default __webpack_public_path__ + "static/media/app-screens-v2-67-2_03.01049d99.jpg";